import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import NextIcon from '@material-ui/icons/SkipNext';
import PrevIcon from '@material-ui/icons/SkipPrevious';
import Button from '@material-ui/core/Button';
import { img } from '../../config';

const useStyles = makeStyles(theme => ({
  wrapper: {
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    '& > div': {
      width: 700,
      maxWidth: '100%',
      background: '#fff',
      padding: 20,
      maxHeight: '100%',
      overflow: 'auto',
    },
    '& h3': {
      color: theme.palette.primary.main,
      textAlign: 'center',
      marginTop: 0,
    },
  },
  img: {
    width: '100%',
    paddingBottom: '62.7%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    margin: '0 auto',
    boxSizing: 'border-box',
    position: 'relative',
    '& > div': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden',
      color: theme.palette.primary.main,
      fontSize: '1.5em',
      padding: '14% 15% 0',
      boxSizing: 'border-box',
      textAlign: 'center',
    }
  },
  action: {
    textAlign: 'center',
    verticalAlign: 'middle',
    marginTop: 20,
    '& button': {
      margin: '0 3px',
      verticalAlign: 'middle',
    },
    '& > span': {
      display: 'inline-block',
      minWidth: 53,
      verticalAlign: 'middle',
      userSelect: 'none',
    },
  },
  '@media(max-width: 850px)': {

  }
}));

function PlayIt(props) {
  const classes = useStyles();
  const [ no, setNo ] = useState(0);
  const { exercise, startStats, finishExercise, action, type } = props.exerciseProps;
  const len = exercise.length;

  useEffect(() => {
    init();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (no === len - 1) finishExercise();
    // eslint-disable-next-line
  }, [no]);

  const init = () => {
    startStats(type);
  }

  const next = () => {
    action();
    if (no < len - 1) {
      setNo(no + 1);
    }
  }

  const prev = () => {
    if (no > 0) setNo(no - 1);
    action();
  }

  return (
    <div className={classes.wrapper}>
      <div>
        <h3>Zagraj to</h3>
        <div className={classes.img} style={{backgroundImage: `url(${img('bg_play_it.png')})`}}>
          <div>
            {exercise[no]}
          </div>
        </div>
        <div className={classes.action}>
          <Button variant="outlined" color="secondary" onClick={prev} disabled={no === 0}><PrevIcon /></Button>
          <span>{no + 1}/{len} </span>
          <Button variant="outlined" color="secondary" onClick={next} disabled={no === len - 1}><NextIcon /></Button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return { 
    media: state.media,
    mobile: state.mobile,
  }
}

export default connect(mapStateToProps)(PlayIt);